<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'margin:0;')
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
.all-btn {
  background-color: #fc6720;
  border: none;
}
.container {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue